import { createStyles, Theme } from "@material-ui/core";

export const styles = ({spacing}: Theme) => createStyles({
    head: {
        // width: "27%",
        // padding: 0,
        "&:first-child": {
            // paddingLeft: spacing.unit * 2,
            // width: "17%"
        },
        "&:last-child": {
            // paddingRight: "50px",
            // width: "32%"
        }
    }
});


// WEBPACK FOOTER //
// ./src/components/TableHeadSortable/TableHeadSortable.style.tsx